import MyFiancesPage from "components/pages/MyFinancesPage";

export default function CaptureQuickTourPersonalFinance(props) {
    return <MyFiancesPage />
}